import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=174b6b9e&scoped=true&lang=true"
import script from "./Projet.vue?vue&type=script&lang=js"
export * from "./Projet.vue?vue&type=script&lang=js"
import style0 from "./Projet.vue?vue&type=style&index=0&id=174b6b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b6b9e",
  null
  
)

export default component.exports